import clsx from 'clsx';
import React from 'react';

interface Props {
    url: string;
    label: React.ReactNode;
    additionalClasses?: string[];
}

export default function FooterLinksItem({ url, label, additionalClasses = [] }: Props) {
    return (
        <li className={clsx('footer-links-menu__items__item', ...additionalClasses)}>
            <a className="footer-links-menu__items__item__link" href={url}>
                {label}
            </a>
        </li>
    );
}
